import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  Tile,
  TileGroup,
  Typography,
} from '@one-thd/sui-atomic-components';
import { DateTime } from 'luxon';
import React from 'react';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { dateTileOptions } from '../../../constants/order-filter';
import { TDateSelectValues } from '../../../models/common';
import { OrderFilterInput } from './OrderFilterInput';

interface IOrderFilterDateSectionProps {
  showDot: boolean;
  filterDotBaseClassName: string;
  dateSettings: {
    selectedDate: TDateSelectValues | null;
    startDate: DateTime | string | null;
    endDate: DateTime | string | null;
  };
  setDateSettings: React.Dispatch<
    React.SetStateAction<{
      selectedDate: TDateSelectValues | null;
      startDate: string | DateTime | null;
      endDate: string | DateTime | null;
    }>
  >;
  setFilterSettings: React.Dispatch<
    React.SetStateAction<{
      userView: string;
      customDateUsed: boolean;
      showStartCalendar: boolean;
      showEndCalendar: boolean;
      invalidStartDate: boolean;
      invalidEndDate: boolean;
    }>
  >;
  onDateSelect: (
    _event: React.SyntheticEvent<Element, Event>,
    date: string,
  ) => void;
}

export const OrderFilterDateSection = ({
  showDot,
  filterDotBaseClassName,
  dateSettings,
  setDateSettings,
  setFilterSettings,
  onDateSelect,
}: IOrderFilterDateSectionProps) => {
  return (
    <div className="sui-relative sui-pt-[14px] sui-border-b-1 sui-border-solid sui-border-strong">
      {showDot && (
        <div className={`${filterDotBaseClassName} sui-top-[17px]`} />
      )}
      <Accordion noBorders>
        <AccordionHeader aria-controls="accordion1-content">
          Date
        </AccordionHeader>
        <AccordionBody>
          <div className="sui-mb-[20px]">
            <Typography weight="bold" className="sui-mb-[4px]">
              Enter a custom range:
            </Typography>
            <div className="sui-flex sui-flex-col sui-gap-[12px] sui-w-full sui-items-center">
              <OrderFilterInput
                name="Start date"
                dateType="startDate"
                dateSettings={dateSettings}
                setDateSettings={setDateSettings}
                setFilterSettings={setFilterSettings}
              />
              <OrderFilterInput
                name="End date"
                dateType="endDate"
                dateSettings={dateSettings}
                setDateSettings={setDateSettings}
                setFilterSettings={setFilterSettings}
              />
            </div>
          </div>
          <div className="sui-mb-[12px]">
            <Typography weight="bold" className="sui-mb-[8px]">
              Select a range:
            </Typography>
            <TileGroup
              value={dateSettings.selectedDate}
              onChange={onDateSelect}
              aria-label="date filter"
              orientation="vertical"
            >
              {dateTileOptions.map((option) => {
                const is25MonthDefault =
                  FeatureSwitches.enableLSSCPS25MonthsDefault === true;

                if (is25MonthDefault && option.value === 'last6Months') {
                  return null;
                }

                if (!is25MonthDefault && option.value === 'last25Months') {
                  return null;
                }

                return (
                  <Tile
                    key={option.value}
                    value={option.value}
                    aria-label={option.label}
                  >
                    <Typography className="sui-mr-auto">
                      {option.label}
                    </Typography>
                  </Tile>
                );
              })}
            </TileGroup>
          </div>
        </AccordionBody>
      </Accordion>
    </div>
  );
};
